import { Component } from '@angular/core';

@Component({
  selector: 'app-placeholder-saved-filters',
  templateUrl: './placeholder-saved-filters.component.html',
  styleUrls: ['./placeholder-saved-filters.component.css']
})
export class PlaceholderSavedFiltersComponent {

}
